import React from 'react';
import { BrandMark } from '../BrandMark';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
export function Footer() {
  return <footer className="bg-ink-deep px-4 py-14 text-center sm:py-20" data-id="element-163" data-mp="2f4tl9odue88f">
      <div className="mx-auto w-full max-w-3xl" data-id="element-164" data-mp="2f421datlxyxz">
        <BrandMark inverted data-id="element-165" data-mp="2a57adllhl42s" />
        <p className="mt-4 text-[11px] font-extrabold uppercase tracking-[0.18em] text-cyan-brand" data-id="element-166" data-mp="2a71tcud76m48">
          A clinical decision-navigation system for physicians
        </p>
        <h2 className="mt-3 font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-167" data-mp="1hhul33nxyi5s">
          Find the scenario. Follow the route. Structure the decision.
        </h2>
        <p className="mt-4 text-[15px] text-white/70" data-id="element-168" data-mp="1rfiqcnj6b827">
          Your patient has a renal question. Now you have a route.
        </p>

        <div className="mt-8" data-id="element-169" data-mp="13odcuf0pgrv2">
          <CTAButton label="Get Renal Decision Desk™ — $27" sub="Instant access • Lifetime access • 7-day guarantee" data-id="element-170" data-mp="13nk2l42jfk86" />
          <CountdownTimer data-id="element-171" data-mp="1eh0yr5g7l6yj" />
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-[12px] leading-relaxed text-white/45" data-id="element-172" data-mp="1efzkyt7t66d4">
          Renal Decision Desk™ is an educational resource for healthcare
          professionals. It does not replace individual clinical judgment, the
          physician-patient relationship, current clinical guidelines,
          prescribing information, or appropriate specialist consultation.
        </p>
        <p className="mt-4 text-[12px] font-medium text-white/40" data-id="element-173" data-mp="vlawri8a0akn">
          © 2026 Dr. Karito. All rights reserved.
        </p>
        <p className="mt-16 text-[11px] text-white/30 sm:mt-8" data-id="element-174" data-mp="14k5z2j8790io">
          {/* spacing for the floating CTA bar */}
        </p>
      </div>
    </footer>;
}